/**
 * stringからenumの値を取得します。
 * 型変換のように使います.
 * enumの要素は文字列が代入されている必要があります
 * <pre>
 *     const possibleOfEnum: string = getStringValue();
 *     const enumValue: SomeEnum = enumFromString(SomeEnum, possibleOfEnum);
 * </pre>
 * @param t 取得したいenum
 * @param value enumを探す文字列.
 */
export const enumFromString = <T>(t: {[key:string]: any}, value: string): T | undefined => {
    type enumType = keyof typeof t;
    const foundKey = Object.keys(t).find((key) => t[key as enumType] === value);
    if (foundKey) {
      return t[foundKey as enumType];
    }
    return undefined;
};
